<template>
<div class="LayoutHolder" id="PageTop">
    <Header/>
    <router-view />
    <Footer/>
</div>  
<CookieBanner/>
</template>
<script>

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import CookieBanner from "@/components/CookieBanner.vue"
import store from '@/store';

export default {
    name: "RootHome",
    components:{
        Header,
        Footer,
        CookieBanner
    },
    created(){

        this.$store.dispatch({
                type: 'getCatalogsFromApi',
                token: this.$store.getters.getToken,
                codiceLingua: this.$store.getters.getLingua  
            }).then(
                (data) => {if(!data) this.$router.push("/")}
            );
/*
        this.$store.dispatch({
            type: 'getOrangeSemaphoreFromApi',                
            token: this.$store.getters.getToken,
            idSemaforo: process.env.VUE_APP_ID_CATALOGO_ARANCIONE                 
                
        }).then(
            (data) => {if(!data) this.$router.push("/")}
        );*/
    },
    beforeRouteEnter (to, from, next) {
        store.dispatch({
                type: 'getResourcesFromApi',
                token: store.getters.getToken,
                codShop: "B2B"
            }).then(
                (data) => {
                    if(!data){
                        next("/")
                    }
                    else{
                        next();
                    }
                }
            );     
    }
}
</script>